import Axios from "../../api/Axios";
const BASE_URL = "ServiceInvoice/";

export const EndpointServiceInvoice = {
    PopulateSupplier: "PopulateSupplier",
    PopulateSSR: "PopulateSSR",
    GetAllSerInv: "GetAllSerInv",
    CheckCrossQuarter: "CheckCrossQuarter",
    GetInvoiceCountforSSR: "GetInvoiceCountforSSR",
    SupgeogId: "SupgeogId",
    CompgeogId: "CompgeogId",
    Save: "Save",
    PrintServiceInv : "PrintServiceInv",
    WriteSignedCodeToPDF : "WriteSignedCodeToPDF",
    RetryEInv : "RetryEInv",
    GetInvDetailsByUsrId : "GetInvDetailsByUsrId",
    SaveSInvStatus : "SaveSInvStatus",
    PopulateSIDetailData : "PopulateSIDetailData",
    PopulateRSESupplier : "PopulateRSESupplier",
    PopulateRSEServiceDetails : "PopulateRSEServiceDetails",
    SendRSEMail : "SendRSEMail",
    CancelRSEServiceInvoice : "CancelRSEServiceInvoice",
    GetSSRIncentive : "GetSSRIncentive",
    GetPreviousInvoice : "GetPreviousInvoice",
    CancelUrbanServiceInvoice : "CancelUrbanServiceInvoice",
    PopulateUrbanCustomer : "PopulateUrbanCustomer",
    GetSerInvByHdrId : "GetSerInvByHdrId",
    UrbanRetryEInv : "UrbanRetryEInv",
    SendUrbanRSEMail : "SendUrbanRSEMail",
};

export const createAPIEndpointServiceInvoice = () => {
    return { 
        get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        post: (Endpoint,data)=> Axios.post(BASE_URL+Endpoint,data)
    };
};